import { useContext } from "react";

import { ToastContext } from "../contexts";

export const useToast = () => {
  const { addToast } = useContext(ToastContext);

  return addToast;
};
